import type { AttributesState } from './types';

const initialState: AttributesState = {
  matches: {},
  profiles: {},
};

export default initialState;
